import type { Category } from "@/types";
import type { ResponsePayload } from "@/types";
import { getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getCategories = async (
  token: string,
  baseUrl: string,
  projectId: string,
  brainstormerId: string,
  params?: object,
  config?: object
): Promise<Array<Category>> => {
  const queryPath = `${baseUrl}/projects/${projectId}/brainstormers/${brainstormerId}/categories`;

  return await getData(token, queryPath, params, config).then(
    (response: ResponsePayload) => deserialize(response.data)
  );
};
